/* oxlint-disable react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md */
import { useQuery } from '@apollo/client';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { PriorAuthorizationStatus } from '../../components/prior-authorization/PriorAuthorizationStatus';
import { getFragment } from '../../graphql';
import {
    GetPrescriberOrderDocument,
    GetPriorAuthorizationDocument,
} from '../../graphql/generated/graphql';
import { useFlags } from '../../hooks/use-flags';
import { Loader } from '../../loaders';
import { getAbsoluteRoute } from '../../util';

const PriorAuthorizationRoute = () => {
    const { priorAuthorizationId } = useParams();
    const { nonDrxPriorAuthorizationEnabled } = useFlags();
    const { state } = useLocation();

    if (!priorAuthorizationId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const { data: priorAuthData, loading: priorAuthLoading } = useQuery(
        GetPriorAuthorizationDocument,
        {
            variables: { priorAuthorizationId },
            errorPolicy: 'all',
        }
    );

    const priorAuthorization = priorAuthData
        ? getFragment(priorAuthData.priorAuthorization)
        : null;
    const drxIds = priorAuthorization?.drxIds || [];

    // Use prescriberOrderId from navigation state if present, otherwise fall back to last drxId in array
    let prescriberOrderId = state?.prescriberOrderId;
    if (!prescriberOrderId) {
        prescriberOrderId = drxIds.at(-1) || '';
    }

    const { data: prescriberOrderData, loading: prescriberOrderLoading } =
        useQuery(GetPrescriberOrderDocument, {
            variables: { prescriberOrderId },
            skip: !prescriberOrderId,
            errorPolicy: 'all',
        });

    if (priorAuthLoading || prescriberOrderLoading) return <Loader />;

    if (!priorAuthData?.priorAuthorization || !priorAuthorization) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    let prescriberOrder;
    if (
        prescriberOrderData?.prescriberOrder?.__typename ===
        'DigitallyReceivedPrescriberOrder'
    ) {
        prescriberOrder = getFragment(prescriberOrderData.prescriberOrder);
    }

    const location = getFragment(priorAuthorization.assignedPharmacyProvider);

    if (!nonDrxPriorAuthorizationEnabled && !prescriberOrder)
        return <Navigate to={getAbsoluteRoute('home')} />;

    return (
        <PriorAuthorizationStatus
            prescriberOrder={prescriberOrder}
            priorAuthInfo={priorAuthorization}
            location={location}
        />
    );
};

export default PriorAuthorizationRoute;
